import { render, staticRenderFns } from "./consult-info6.vue?vue&type=template&id=66e3f6b8&scoped=true"
import script from "./consult-info6.vue?vue&type=script&lang=js"
export * from "./consult-info6.vue?vue&type=script&lang=js"
import style0 from "./consult-info6.vue?vue&type=style&index=0&id=66e3f6b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e3f6b8",
  null
  
)

export default component.exports